export default __webpack_public_path__ + "static/media/Afterdark-img.4ec66ae4.jpg";